import { Injectable } from '@angular/core';
import {
  IVerifonePurchaseRequest,
  IVerifonePurchaseTransactionExtendedData,
  IVerifoneRefundRequest,
  VerifoneReceiptPrintMethod,
  type IInvoice,
  type IPracticeVerifoneSettings,
} from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';
import { ITransactionActionsData } from '../transaction-action';
import { type ITransactionAmountDialogResult } from '../transaction-components/transaction-amount-dialog/transaction-amount-dialog.component';
import { TransactionAmountDialog } from '../transaction-components/transaction-amount-dialog/transaction-amount-dialog.service';
import { type VerifoneTerminalFormData } from './select-verifone-terminal/select-verifone-terminal.component';

@Injectable()
export class VerifonePurchaseBuilder {
  constructor(private _amountDialog: TransactionAmountDialog) {}

  buildPurchaseRequest(
    invoice: WithRef<IInvoice>,
    formData: ITransactionAmountDialogResult,
    terminalData: VerifoneTerminalFormData,
    verifoneSettings?: IPracticeVerifoneSettings
  ): IVerifonePurchaseRequest {
    return {
      practiceRef: invoice.practice.ref,
      terminal: terminalData,
      amount: formData.amount,
      testModeEnabled: verifoneSettings?.testModeEnabled,
      receiptPrintMethod:
        verifoneSettings?.receiptPrintMethod ??
        VerifoneReceiptPrintMethod.Terminal,
    };
  }

  buildRefundRequest(
    invoice: WithRef<IInvoice>,
    formData: ITransactionAmountDialogResult,
    terminalData: VerifoneTerminalFormData,
    verifoneSettings?: IPracticeVerifoneSettings
  ): IVerifoneRefundRequest {
    return {
      practiceRef: invoice.practice.ref,
      terminal: terminalData,
      amount: formData.amount,
      testModeEnabled: verifoneSettings?.testModeEnabled,
      receiptPrintMethod:
        verifoneSettings?.receiptPrintMethod ??
        VerifoneReceiptPrintMethod.Terminal,
    };
  }

  async openPurchaseForm(
    invoice: WithRef<IInvoice>
  ): Promise<ITransactionAmountDialogResult | undefined> {
    return this._amountDialog.openForInvoice(
      'Verifone - EFTPOS Payment',
      invoice
    );
  }

  async openRefundForm(
    actionsData: ITransactionActionsData<IVerifonePurchaseTransactionExtendedData>
  ): Promise<ITransactionAmountDialogResult | undefined> {
    return this._amountDialog.openForRefund(
      'Verifone - EFTPOS Refund',
      actionsData
    );
  }
}
